import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import './ExternalOfferLoginStyle.less';

export interface IState {
  refreshNeeded: boolean;
  currentAction: string;
}

interface IExternalOfferLoginParams {
  token: string;
}

export type IProps = RouteComponentProps<IExternalOfferLoginParams>;

export default class ExternalOfferLogin extends React.Component<IProps, IState> {
  public state: IState = {
    currentAction: 'Login',
    refreshNeeded: false,
  };

  public render() {
    const { currentAction } = this.state;

    return (
      <div className="od-offer-login-page">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 od-error-details">
              <h4>You need to be logged into admin to view this offer.</h4>
              <h4>Click the button below to login, then refresh this page.</h4>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 od-login">
              <a className="button secondary login-refresh-button" onClick={this.onClickChange}>
                <h5>{currentAction}</h5>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private onClickChange = () => {
    const { token } = this.props.match.params;
    const { refreshNeeded } = this.state;
    const adminUrl = '/admin/properties?query=needs_attention';
    if (!refreshNeeded) {
      window.open(adminUrl, '_blank');
      this.setState({ refreshNeeded: true, currentAction: 'Refresh Page' });
    } else {
      window.location.assign(`/external_tooling/v1/compose-offer/${token}`);
    }
  };
}
